module.exports = __webpack_public_path__ + "static/img/tt-5.541b1fc.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/image/tt-5.jpg
 ** module id = 593
 ** module chunks = 2
 **/